import React from "react";
import "./styles/Information.css";
import Footer from "../components/Footer";
import { connect } from "react-redux";
import donationIcon from "../assets/donaciones.svg";

const CONTENT = {
  es: {
    title: "¿Qué es Donar?",
    paragraphs: [
      "Donación es el acto y el resultado de donar, regalar, ceder de manera voluntaria, traspasar algo sin esperar nada a cambio. El concepto proviene del vocablo latino donatio dar.",
      "Por lo general una donación consiste en la entrega de dinero o bienes como una acción caritativa. Quien realiza la donación espera que su aporte ayude a mejorar la calidad de vida de aquel que necesita asistencia para subsistir o salir adelante.",
      "Muchas organizaciones sin fines de lucro tienen como principal fuente de financiamiento las donaciones de los interesados.",
      "Hay instituciones que reciben donaciones de manera constante para asistir periódicamente a las personas más pobres. En otros casos, se llevan a cabo campañas especiales para ayudar a las víctimas de determinados fenómenos o sucesos (inundaciones, terremotos, guerras civiles, etc.).",
      "Ten en cuenta que en el proceso de Donación del sitio se anuncian las donaciones del Donante (usuarios registrados que deseen donar) y se le vincula con el o los posibles donatarios (usuarios registrados que requieran donaciones). El Donante discriminará a los donatarios y proveerá al que le parezca pertinente bajo sus propios criterios.",
    ],
    note: "Godiway no solicita, ni provee donaciones.",
  },
  en: {
    title: "What is Donating?",
    paragraphs: [
      "Donation is the act and the result of donating, giving away, giving in voluntarily, transferring something without expecting anything in return. The concept comes from the Latin word donatio, to give.",
      "Usually a donation consists of the delivery of money or property as a charitable action. Whoever makes the donation hopes that their contribution will help improve the quality of life of those who need assistance to subsist or get ahead.",
      "Many non-profit organizations have donations from interested parties as their main source of financing.",
      "There are institutions that receive donations constantly to periodically assist the poorest people. In other cases, special campaigns are carried out to help victims of certain phenomena or events (floods, earthquakes, civil wars, etc.).",
      "Bear in mind that in the Donation process of the site, the Donor's donations are announced (registered users who wish to donate) and linked with the potential grantees (registered users who require donations). The Donor will discriminate among the grantees and will provide to the one it deems appropriate under its own criteria.",
    ],
    note: "Godiway does not solicit or provide donations.",
  },
};

class WhatIsDonation extends React.Component {
  render() {
    const content = this.props.lang === "es" ? CONTENT.es : CONTENT.en;

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="container-information">
            <div className="info-card">
              <div className="info-card__header">
                <span className="info-card__icon">
                  <img src={donationIcon} alt="" aria-hidden="true" />
                </span>
                <h1 className="info-card__title">{content.title}</h1>
              </div>
              <div className="info-card__body">
                {content.paragraphs.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
                <p className="info-card__note">{content.note}</p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    lang: reducer.i18n.locale,
  };
}

export default connect(mapStateToProps, null)(WhatIsDonation);
